<template>
    <div id="data-metas-list-view">
        <vx-card class="mb-base" no-shadow card-border>

            <div class="flex items-end mb-2">
                <feather-icon icon="SettingsIcon" class="mr-2" svgClasses="w-5 h-5" />
                <span class="font-medium leading-none">Monitoreo de Personal por Meta</span>
            </div>

            <vs-divider/>

            <div class="flex flex-wrap-reverse items-center justify-start flex-grow">
                <div class="mb-4">
                    <label class="text-sm font-medium opacity-100">Fecha</label>
                    <datepicker :disabledDates="disabledDatesInicio" :language="es" v-model="inputFecha" format="dd/MM/yyyy" v-validate="'required'" name="fecha"></datepicker>
                    <span class="text-sm text-danger" v-show="errors.has('fecha')">{{ errors.first('fecha') }}</span>
                </div>
                <div class="flex flex-wrap items-center justify-end ml-2">
                    <vs-button @click="buscarPorFecha" icon-pack="feather" color="primary" icon="icon-search" class="mt-2 ml-auto">Buscar</vs-button>
                </div>
            </div>

            <vs-table stripe ref="table" :data="itemsMeta" pagination :max-items="itemsPerPage" search noDataText="No existen datos">
                <div slot="header" class="flex flex-wrap-reverse items-center justify-between flex-grow">
                    <vs-dropdown vs-trigger-click class="mb-4 mr-4 cursor-pointer items-per-page-handler">
                        <div class="flex items-center justify-between p-4 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ itemsMeta.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsMeta.length }} de {{ itemsMeta.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="itemsPerPage=5">
                            <span>5</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=25">
                            <span>25</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>

                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th class=""><div class="font-bold">NRO META</div></vs-th>
                    <vs-th v-for="i in lengthHeader" :key="i" class=""></vs-th>
                    <vs-th></vs-th>
                    <vs-th></vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].meta">
                                <vs-chip transparent color="primary" class="">
                                    <span class="cursor-pointer text-primary" @click="showMeta(tr)">{{data[indextr].meta}}</span>
                                </vs-chip>
                            </vs-td>

                            <vs-td :key="indextr" v-for="(item, indextr) in data[indextr].responsables">

                                <div class="flex items-center w-full border-0 border-t-0 border-b-0 border-r-0 vx-col sm:w-3/4 sm:border d-theme-border-grey-light">
                                    <div class="flex flex-col w-full p-2">
                                        
                                        <div class="my-4">
                                            <small class="flex items-start justify-center mt-1 font-bold text-danger">{{ item.nombres }} {{ item.apellidos }}</small>
                                            <p class="text-center">{{ item.numDocumento }}</p>
                                            <span class="flex items-start justify-center mt-1 text-grey">
                                                <small class="text-sm">{{ item.cargo }}</small>
                                            </span>
                                        </div>

                                        <div class="flex flex-wrap-reverse items-center justify-center flex-grow">
                                            <vx-tooltip text="Ver registros" position="top">
                                                <div class="flex flex-wrap items-center justify-end ml-2" v-if="item.hasActivities">
                                                    <vs-button @click="showActivities(tr, item)" icon-pack="feather" color="warning" icon="icon-image" class="ml-auto"></vs-button>
                                                </div>
                                            </vx-tooltip>
                                        </div>
                                        
                                    </div>
                                </div>
                                
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>

            <div class="flex flex-wrap-reverse items-center justify-end flex-grow">
                <p class="text-sm truncate">
                    Mostrando registros del <strong>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}</strong> al <strong>{{ itemsMeta.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsMeta.length }}</strong> de un total de <strong>{{ itemsMeta.length }}</strong> registros
                </p>
            </div>

        </vx-card>

        <vs-popup title="Meta detalle" :active.sync="popupDetalleMeta">
            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3">
                    <span class="flex flex-wrap-reverse justify-end"><strong>META: </strong></span>
                </div>
                <div class="w-full vx-col md:w-2/3">
                    <span class=""> {{ detalleMeta === null ? '' : detalleMeta.meta }} </span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3">
                    <span class="flex flex-wrap-reverse justify-end"><strong>COD. PROY/PROD.: </strong></span>
                </div>
                <div class="w-full vx-col md:w-2/3">
                    <div @click="accessSsi" class="cursor-pointer">
                        <vs-chip color="primary">
                            <vs-avatar color="primary" icon-pack="feather" icon="icon-link-2"/>
                            {{detalleMeta === null ? '' : detalleMeta.codigoProductoProyecto }}
                        </vs-chip>
                    </div>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3">
                    <span class="flex flex-wrap-reverse justify-end"><strong>PROYECTO/PRODUCTO: </strong></span>
                </div>
                <div class="w-full vx-col md:w-2/3">
                    <span class=""> {{ detalleMeta === null ? '' : detalleMeta.productoProyecto }} </span>
                </div>
            </div>

            <vs-divider/>

            <div class="w-full vx-col">
                <div class="flex flex-wrap items-center justify-end">
                    <vs-button @click="popupDetalleMeta=false" icon-pack="feather" color="primary" icon="icon-check" class="mt-2 ml-auto">Aceptar</vs-button>
                </div>
            </div>
        </vs-popup>


        
        <vs-popup title="Registro de Actividades" :active.sync="popupActivities" id="id-popup-activities">
            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3">
                    <small class="flex flex-wrap-reverse justify-end"><strong>META: </strong></small>
                </div>
                <div class="w-full vx-col md:w-2/3">
                    <small class=""> {{ detalleMeta === null ? '' : detalleMeta.meta.meta }} </small>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3">
                    <small class="flex flex-wrap-reverse justify-end"><strong>CUI: </strong></small>
                </div>
                <div class="w-full vx-col md:w-2/3">
                    <div @click="accessSsi" class="cursor-pointer">
                        <vs-chip color="success">
                            <vs-avatar color="warning" icon-pack="feather" icon="icon-link-2"/>
                            <small>{{detalleMeta === null ? '' : detalleMeta.meta.codigoProductoProyecto }}</small>
                        </vs-chip>
                    </div>
                </div>
            </div>

            <div class="vx-row mb-base">
                <div class="w-full vx-col md:w-1/3">
                    <small class="flex flex-wrap-reverse justify-end"><strong>PROYECTO/PRODUCTO: </strong></small>
                </div>
                <div class="w-full vx-col md:w-2/3">
                    <small class=""> {{ detalleMeta === null ? '' : detalleMeta.meta.productoProyecto }} </small>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3">
                    <small class="flex flex-wrap-reverse justify-end"><strong>Responsable: </strong></small>
                </div>
                <div class="w-full vx-col md:w-2/3">
                    <small class=""> {{ activity === null ? '' : activity.apellidos + ' ' + activity.nombres }} </small>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3">
                    <small class="flex flex-wrap-reverse justify-end"><strong>Cargo: </strong></small>
                </div>
                <div class="w-full vx-col md:w-2/3">
                    <small class=""> {{ activity === null ? '' : activity.cargo }} </small>
                </div>
            </div>

            <vs-divider color="primary">Registros Realizados</vs-divider>

            <div class="items-grid-view vx-row mt-base">
                <div class="w-full vx-col lg:w-1/2 md:w-1/2 sm:w-1/2" :key="indextr" v-for="(tr, indextr) in activities">
                    <vx-card class="activity-card mb-base" id="grid-view-activities" shadow card-border>
                        <template slot="no-body">
                             <header class="activity-header">
                                <div class="mt-4 activity-badge">
                                    <span class="activity-title">{{ tr.title }}</span>
                                </div>
                            </header>

                            <section class="activity-description">
                                <div class="px-4 my-4">
                                    <p 
                                        class="description-text"
                                        :title="tr.description"
                                    >
                                        {{ tr.description }}
                                    </p>

                                </div>
                            </section>

                            <section class="activity-coordinates">
                                <div class="items-center justify-start px-4">
                                    <feather-icon icon="MapPinIcon" svgClasses="h-5 w-5 text-primary mr-2" />
                                    <span class="text-sm font-bold text-primary">Coordenadas:</span>
                                    <div class="coordinate-item">
                                        <span class="coordinate-label">Lat:</span>
                                        <span class="coordinate-value">{{ formatCoordinate(tr.latitud) }}</span>
                                    </div>
                                    <div class="coordinate-item">
                                        <span class="coordinate-label">Long:</span>
                                        <span class="coordinate-value">{{ formatCoordinate(tr.longitud) }}</span>
                                    </div>
                                </div>
                            </section>

                            <footer class="activity-footer">
                                
                                <div class="w-full vx-col">
                                    <div class="flex flex-wrap items-center justify-between mb-4 mr-4">
                                        <div class="px-4">
                        
                                            <time class="activity-date">
                                                Fecha: {{ tr.fechaRegistro }}
                                            </time>
                                           
                                        </div>
                                        <vs-button @click="showMap(tr)" icon-pack="feather" color="primary" icon="icon-map-pin" class="mt-2 ml-auto">Ver</vs-button>
                                    </div>
                                </div>
                            </footer>

                        </template>
                    </vx-card>
                </div>

                
            </div>

            <vs-divider/>

            <div class="w-full vx-col">
                <div class="flex flex-wrap items-center justify-end">
                    <vs-button @click="popupActivities=false" icon-pack="feather" color="danger" icon="icon-check" class="mt-2 ml-auto">Aceptar</vs-button>
                </div>
            </div>
            
        </vs-popup>

    </div>
</template>
<script>
import GoogleMaps from '../components/GoogleMaps.vue';
import MapsReponsable from '../components/MapsReponsable.vue';
import Datepicker from 'vuejs-datepicker';
import { es } from 'vuejs-datepicker/src/locale';

import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
const VUE_APP_MAP_ACCESS_TOKEN='pk.eyJ1IjoiY29uc2FjaGFwaSIsImEiOiJjbGh6ZWxscG4wMnVsM3NteHFhYXM0YTBqIn0.d_FvFlICiWjVzsOwR7RJTQ';
export default {
    components: {
        GoogleMaps,
        MapsReponsable,
        Datepicker,
        mapboxgl
    },

    data(){
        return {
            es                  : es,
            lengthHeader        : 3,
            nombreReponsable    : '',
            itemsMeta           : [],
            itemsPerPage        : 10,
            isMounted           : false,

            inputFecha          : new Date(),
            detalleMeta         : null,
            disabledDatesInicio : {
                to: new Date(new Date().getFullYear(), new Date().getMonth() - 2, new Date().getDate()),
                from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
            },
            
            
            popupDetalleMeta    : false,
            popupActivities     : false,
            
            activities: [],
            activity: null,

            location: "",
            access_token: VUE_APP_MAP_ACCESS_TOKEN,
            center: [-71.9634369, -13.5243935],
            map: {},
        }
    },

    computed: {
        currentPage () {
            if (this.isMounted) {
                return this.$refs.table.currentx;
            }
            return 0;
        },
    },

    mounted () {
        this.isMounted = true;
        this.getMetas();
    },

    methods: {
        getMetas(){
            this.$vs.loading();
            this.$http.metasHabilitadosPorEjecutora()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    const data = response.data;
                    this.itemsMeta = data;
                    data.forEach((item)=>{
                        if(item.responsables.length > this.lengthHeader){
                            this.lengthHeader = item.responsables.length;
                        }
                    });
                }
            }).catch(error => {
                this.$vs.loading.close();
                if(error.message === "Network Error"){
                    this.showMessageError(500, '');
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        showMeta(tr){
            this.$vs.loading();
            this.$http.searchMeta(tr.meta)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    const data = response.data;
                    this.detalleMeta = data;
                    this.popupDetalleMeta = true;
                }
            }).catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        buscarPorFecha(){
            if(this.inputFecha === null){
                this.showMessageAlert('Seleccione la fecha para realizar la consulta.');
                return;
            }
            let dayFin = `${(this.inputFecha.getDate())}`.padStart(2,'0');
            let monthFin = `${(this.inputFecha.getMonth()+1)}`.padStart(2,'0');
            let yearFin = this.inputFecha.getFullYear();

            const fecha = `${ dayFin }-${ monthFin }-${ yearFin }`;

            this.$vs.loading();
            this.$http.metasHabilitadosPorEjecutoraYFecha(fecha)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    const data = response.data;
                    this.itemsMeta = data;

                    data.forEach((item)=>{
                        if(item.responsables.length > this.lengthHeader){
                            this.lengthHeader = item.responsables.length;
                        }
                    });
                }
            }).catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        showMap(item){
            console.log(item);
            this.popupActivities = false;
            this.$router.push({
				name: 'monitoreo-diario-meta-detalle',
				params: { id: item.id }
			}).catch(() => {});
        },

        showActivities(tr, item){
            this.$vs.loading();
            this.$http.buscarMetaLocalizacion(tr.id)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    const data = response.data;
                    this.detalleMeta = data;
                    this.popupActivities = true;
                    this.activities = item.actividades;
                    this.activity = item;
                    this.latitudProject = tr.latitud;
                    this.longitudProject = tr.longitud;
                    //this.getFeatures(data.codigoProductoProyecto, tr.finalidad, tr.latitud, tr.longitud, item.actividades);
                }
            }).catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        getFeatures(cui, proyecto, x, y, activities){
            let features = [];
            let isProject = true;
            
            if(isProject){
                
                const ssi =  `https://ofi5.mef.gob.pe/repseguim/proyinv09.html?codigo=${ cui }`;
                const desc = `<strong><a href="${ ssi }" target="_blank" title="Ver en SSI">CUI ${ proyecto }</a><br></strong><strong>Nombre de Inversión: </><p>${ proyecto.nombre }</p>`;
                if(x !== null && y !== null){
                    const feature = {
                        'type': 'Feature',
                        'properties': {
                            'description': desc,
                            'icon': 'theatre',
                            "color": "#0746b9"
                        },
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [parseFloat(x), parseFloat(y)],
                        }
                    };
                    features.push(feature);
                }
                isProject = false;
            }

            activities.forEach((item)=>{
                const latid = item.latitud;
                const longi = item.longitud;
                const detall = `
                <strong class="font-bold text-danger">${ item.titulo }</strong>
                <br>
                <strong class="text-danger"><small class="font-bold text-primary">${ item.fechaRegistro }</small></strong>`;
                if(latid !== null && longi !== null){
                    const feature = {
                        'type': 'Feature',
                        'properties': {
                            'description': detall,
                            'icon': 'theatre',
                            "color": "#C00000"
                        },
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [parseFloat(longi), parseFloat(latid)],
                        }
                    };
                    features.push(feature);
                }
            });


            this.createMap(features);
        },

        async createMap(values) {
            try {
                mapboxgl.accessToken = this.access_token;
                this.map = new mapboxgl.Map({
                    container: this.$refs.mapMeta, // container ID
                    style: "mapbox://styles/mapbox/streets-v11",
                    center: this.center,
                    zoom: 7.6,
                    //projection: 'globe'
                });

                this.map.on('load', () => {
                    this.map.addSource("places", {
                        "type": "geojson",
                        "data": {
                            'type': 'FeatureCollection',
                            'features': values
                        }
                    })
                    this.map.addLayer({
                        'id': 'places',
                        'type': 'circle',
                        'source': 'places',
                        'paint': {
                            'circle-color': ['get', 'color'],
                            'circle-radius': 12,
                            'circle-stroke-width': 2,
                            'circle-stroke-color': '#ffffff'
                        }
                    });

                    this.map.on('click', 'places', (e) => {
                        const coordinates = e.features[0].geometry.coordinates.slice();
                        const description = e.features[0].properties.description;
                        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                        }
                        
                        new mapboxgl.Popup()
                        .setLngLat(coordinates)
                        .setHTML(description)
                        .addTo(this.map);
                    });

                    this.map.on('mouseenter', 'places', () => {
                        this.map.getCanvas().style.cursor = 'pointer';
                    });
                    
                    this.map.on('mouseleave', 'places', () => {
                        this.map.getCanvas().style.cursor = '';
                    });
                });

            } catch (err) {
                console.log("map error: ", err);
            }
        },
        
        accessSsi(){
            if(this.detalleMeta === null){
                this.$vs.dialog({
                    type: 'alert',
                    color: 'danger',
                    title: `Aviso`,
                    text: 'Seleccione la meta.',
                    acceptText: 'Aceptar',
                });
                return;
            }
            window.open("https://ofi5.mef.gob.pe/repseguim/proyinv09.html?codigo=" + this.detalleMeta.codigoProductoProyecto, '_blank').focus();
        },

        statusColor(status) {
            if (status === 1) return 'text-warning'
            if (status === 2) return 'text-success'
            return 'text-primary'
        },

        statusColorBorder(status) {
            if (status === 1) return 'border-warning'
            if (status === 2) return 'border-success'
            return 'border-primary'
        },

        formatCoordinate(coordinate) {
            if (typeof coordinate !== 'number') return coordinate
            return Number(coordinate).toFixed(6)
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.popupRiesgo = false;
                this.popupEliminar = false;
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupRiesgo = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        }
    },
}


</script>
<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";

#data-metas-list-view {
.vs-con-table {
    @media (max-width: 689px) {
        .vs-table--search {
            margin-left: 0;
            max-width: unset;
            width: 100%;

            .vs-table--search-input {
                width: 100%;
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 0.0rem;
        margin-right: 0.0rem;
        > span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search{
            padding-top: 0;

            .vs-table--search-input {
                padding: 1.0rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }

    .vs-table {
        font-size: 0.88rem;
        font-weight: 400;
        tr {
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td {
                padding: 10;
            }
            td.td-check {
               padding: 20px !important;
            }
        }
    }

    .vs-table--thead{
        th {
            padding: 10;
            background: #d9d8d8;
      
            &:first-child{
                border-top-left-radius: .3rem;
                border-bottom-left-radius: .3rem;
            }
            &:last-child{
                border-top-right-radius: .3rem;
                border-bottom-right-radius: .3rem;
            }
            .vs-table-text{
                text-transform: uppercase;
                font-weight: 600;
            }
        }
        th.td-check{
            padding: 0 15px !important;
        }
        tr{
            background: none;
            box-shadow: none;
        }
    }

    .vs-table--pagination {
        justify-content: center;
    }
  }
}

#grid-view-activities {
    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}

.activity-header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.activity-badge {
  display: flex;
  padding: 0.5rem 0.75rem;
  border: 1px solid #fca5a5;
  border-radius: 0.5rem;
  color: #dc2626;
  background-color: #fef2f2;
}

.activity-title {
  font-size: 0.875rem;
  font-weight: 700;
  margin: 0;
}

.activity-description {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.activity-coordinates {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.coordinate-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
}

.coordinate-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #2563eb;
  min-width: max-content;
}

.coordinate-value {
  font-size: 0.875rem;
  color: #2563eb;
}

.activity-footer {
  border-top: 1px solid #f3f4f6;
  padding-top: 0.75rem;
}

.activity-date {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}

.activity-card {
  overflow: hidden;
  margin-bottom: 1rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: fit-content;
  border-radius: 0.5rem;
  background: #E9F2FB;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.activity-card:hover {
  transform: scale(1.02);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}


#id-popup-activities {
    .vs-popup {
        width: 790px;
    }
    .vs-con-table {
        .vs-table--thead {
            th {
                background: #d9d8d8;
            }
        }
    }
}

</style>